"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgNetwork = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_NETWORK", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M15.711 6.37c.389-.406.391-1.068-.029-1.438C13.607 3.102 10.927 2 8 2 5.073 2 2.393 3.102.318 4.932c-.42.37-.418 1.032-.03 1.438.388.405 1.013.401 1.438.04C3.436 4.95 5.62 4.076 8 4.076s4.564.874 6.274 2.332c.425.362 1.05.366 1.438-.039Z" }),
    React.createElement("path", { d: "M12.9 9.308c.39-.406.392-1.072-.043-1.423A7.697 7.697 0 0 0 8 6.154c-1.83 0-3.514.646-4.857 1.731-.435.351-.432 1.017-.044 1.423.387.404 1.011.397 1.457.067A5.76 5.76 0 0 1 8 8.23a5.76 5.76 0 0 1 3.444 1.145c.446.33 1.07.337 1.457-.067ZM8.703 13.696l1.428-1.493c.37-.388.374-1.014-.08-1.3a3.828 3.828 0 0 0-4.102 0c-.455.286-.45.912-.08 1.3l1.429 1.493a.963.963 0 0 0 1.405 0Z" }))); };
exports.default = SvgNetwork;
